"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCssVariableDefinitionsMap = void 0;
var addExtraThemeEntries_1 = require("./addExtraThemeEntries");
var cssVariables_1 = require("./cssVariables");
var mapLeafsOfObject_1 = require("./mapLeafsOfObject");
/**

 * Make a map of CSS variables -> values in a consistent way.
 * Use this to, for example, create a CSS file that declares each theme variable on the `:root` pseudo element.
 * Or for example when you're defining CSS variables using `rootElement.style.setProperty` within ThemeManager.
 *
 * It is paramount that this function defines every variable that {@link makeCssVariableTheme} expects to be defined.
 * Otherwise, it's possible that a CSS variable token (something that looks like var(--color-purple-100-rgb)) won't have a matching defined
 * CSS variable like `--color-purple-100-rgb: 123, 123, 123;`
 *
 *
 * For example:
 * Input:
 * ```
 * {
 *      color: {
 *        whatever: {
 *          100: "#ff0022"
 *        }
 *      }
 * }
 * ```
 * Output:
 * ```
 * {
 *  "--color-whatever-100": "#ff0022"
 * }
 */
function makeCssVariableDefinitionsMap(theme) {
    var accumulatedCssVariables = {};
    // Shamelessly using a map function like a forEach
    (0, mapLeafsOfObject_1.mapLeafsOfObject)(theme, function (path, value) {
        // Key will be `--color-blah`
        var key = (0, cssVariables_1.objectPathToCssVarIdentifier)(path);
        var nextCssVariables = (0, addExtraThemeEntries_1.addExtraThemeEntries)(path, key, value, function (_, v) { return "".concat(v); }, { augmentWithId: false });
        accumulatedCssVariables = __assign(__assign({}, accumulatedCssVariables), nextCssVariables);
    });
    return accumulatedCssVariables;
}
exports.makeCssVariableDefinitionsMap = makeCssVariableDefinitionsMap;
//# sourceMappingURL=makeCssVariableDefinitionsMap.js.map